import React from 'react';

import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { Tooltip } from '@bringg/react-components';
import { ResponseItem } from '@bringg/types';
import { DetailedCellProps } from '@bringg-frontend/monitoring-shared';

const RequiredSkillsCell = ({ row }: DetailedCellProps<ResponseItem>) => {
	const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id);
	const { required_skills } = task;
	const skills = required_skills?.join(', ') || '';

	return (
		<Tooltip title={skills}>
			<span data-test-id="required-skills-cell">{skills}</span>
		</Tooltip>
	);
};

export default RequiredSkillsCell;
